import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import { get } from 'lodash';
import moment from 'moment';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { SizeFittingTable } from 'src/components/Antd';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import Pagination from 'src/components/StyledPagination/GlobalPagination';
import { useI18n } from 'src/hooks/useRouterChange';
import { allInventoryDetails } from 'src/request/inventory/inventory';
import { defaultPageSize } from 'src/tools/constant';
import { i18nGet } from 'src/tools/tools';
import { EnumTablePosition } from 'src/types/common/common';
import { EEvent, eventDic } from 'src/types/common/inventory';
import css from './InventoryHistory.less';

const breadcrumbData = ({ getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '',
    name: getI18n('general.products'),
  },
  {
    url: '/inventoryList',
    name: getI18n('inventory.inventory.list_general_pageLayoutProps_title'),
  },
  {
    url: '',
    name: getI18n('inventory.inventory.inventoryHistory'),
  },
];

const AllInventoryHistory = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [current, setCurrent] = useState(0);
  const params: any = useParams();
  const { productUuid = '' } = params;
  const history = useHistory();
  const [total, setTotal] = useState(0);
  const [stockTotal, setStockTotal] = useState(0);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [product, setProduct] = useState<any>({});
  const pageOnChange = (index) => {
    if (index && index > 0) {
      setCurrent(index - 1);
    }
  };
  const pageSizeChange = (size) => {
    const { value } = size;

    setPageSize(value);
  };
  const getInventoryHistory = () => {
    if (!loading) {
      setLoading(true);
    }
    allInventoryDetails(productUuid, current * pageSize, pageSize).then(
      (res): any => {
        // console.log('res', res);
        const totalStock = get(res, 'totalStock');
        const historyItems = get(res, 'historyItems');
        //const inventory = get(res, 'inventory');
        const product = get(res, 'product');

        const { results, totalCount } = historyItems || {};
        // const { total } = inventory || {};

        setTotal(totalCount);

        setProducts(results);
        setLoading(false);
        setProduct(product || {});
        setStockTotal(totalStock);
      },
    );
  };
  React.useEffect(() => {
    console.log(params);
    getInventoryHistory();
  }, [current, pageSize]);
  const columns = [
    {
      title: getI18n('inventory.inventory.detail_general_Date'),
      dataIndex: 'createdDate',
      key: 'createdDate',
      default: true,
      optional: false,
      className: css.columnClass,
      width: 190,
      childGenerate: (text) => (
        <NoWrapContainer>
          <Tooltip title={moment(text).format('MM-DD-YYYY hh:mm:ss a')}>
            {moment(text).format('MM-DD-YYYY hh:mm:ss a')}
          </Tooltip>
        </NoWrapContainer>
      ),
    },
    {
      title: getI18n('inventory.inventory.detail_general_Event'),
      dataIndex: 'event',
      default: true,
      optional: true,
      key: 'event',

      minWidth: 190,
      childGenerate: (text) => (
        <NoWrapContainer>
          <Tooltip title={eventDic[text]}>{eventDic[text]}</Tooltip>
        </NoWrapContainer>
      ),
    },
    {
      title: getI18n('inventory.inventory.managedby'),
      dataIndex: 'managedBy',
      default: true,
      optional: true,
      key: 'fullName',
      childGenerate: (text) => (
        <Tooltip title={get(text, 'fullName')}>
          {get(text, 'fullName') || '-'}
        </Tooltip>
      ),
      minWidth: 190,
    },
    {
      title: getI18n('inventory.inventory.detail_general_Notes'),
      dataIndex: 'notes',
      default: true,
      optional: true,
      key: 'notes',
      className: css.columnClass,
      minWidth: 190,
      childGenerate: (text) => (
        <NoWrapContainer>
          <Tooltip title={text}>{text}</Tooltip>
        </NoWrapContainer>
      ),
    },
    {
      title: getI18n('inventory.inventory.detail_general_Warehouse'),
      dataIndex: 'warehouseName',
      default: true,
      optional: true,
      key: 'Warehouse',
      minWidth: 190,
      childGenerate: (text) => (
        <NoWrapContainer>
          <Tooltip title={text}>{text || '-'}</Tooltip>
        </NoWrapContainer>
      ),
      //<Tooltip title={warehouseName}>{warehouseName}</Tooltip>
    },

    {
      position: EnumTablePosition.right,
      titleGenerate: () =>
        getI18n('inventory.inventory.detail_general_Adjustment'),
      dataIndex: 'amount',
      default: true,
      optional: true,
      align: 'adjustment',
      key: 'Adjustment',
      minWidth: 120,
      childGenerate: (text, record) => {
        const event = get(record, 'event');
        const isAuto = event === EEvent.AutoSubtracted;
        return isAuto ? (
          '-'
        ) : (
          <Tooltip title={text}>
            <div className={text > 0 ? css.green : css.red}>
              {text > 0 && '+'}
              {text}
            </div>
          </Tooltip>
        );
      },
    },
    {
      titleGenerate: () =>
        getI18n('inventory.inventory.list_AllList_totalstock_title'),
      position: EnumTablePosition.right,
      dataIndex: 'available ',
      default: true,
      optional: true,
      key: 'available',
      className: css.columnClass,
      minWidth: 120,
      childGenerate: (text, record) => (
        <Tooltip title={record.available}>{record.available}</Tooltip>
      ),
    },
  ];
  const topRight = (
    <TopLeft
      goBack={() => {
        history.push('/inventoryList');
      }}
      breadcrumbData={breadcrumbData({ getI18n })}
    />
  );
  return (
    <React.Fragment>
      <Layout elements={[]} topLeft={topRight} />
      <div className={css.inventoryHistory}>
        <div className={css.title}>
          <p>
            <span className={css.titleOne}>{product.sku}</span>
            {product.name}
          </p>

          <span className={css.titleRight}>
            {getI18n('inventory.inventory.currentStock')}:{stockTotal || '-'}
          </span>
        </div>
        <SizeFittingTable
          rowKey='uuid'
          className={css.table}
          pagination={false}
          id='ProductSetProductsSelectionTable'
          columns={columns}
          dataSource={products}
          rowSelection={false}
          loading={loading}
        />
        <Pagination
          current={current + 1}
          total={total}
          pageSize={pageSize}
          pageOnChange={pageOnChange}
          pageSizeChange={pageSizeChange}
          paginationProps={{ defaultPageSize: pageSize }}
        />
      </div>
    </React.Fragment>
  );
};
export default AllInventoryHistory;
